<template>
  <div class="work-bench-select-container">
    <el-select v-model="selectedMapId" filterable clearable size="small" placeholder="选择底图开始工作"
      popper-class="work-bench-select-dropdown"
      @change="handleMapChange" @clear="handleClear">
      <el-option v-for="item in mapList" :key="item.mapId" :label="item.mapName" :value="item.mapId" />
    </el-select>
  </div>
</template>

<script setup>
import {
  onMounted,
  ref,
} from 'vue';
import { queryAllTypeMapList } from '@/api/MapManage';

const emit = defineEmits([
  'mapChange'
]);

const mapList = ref([]);
const selectedMapId = ref('');

const queryAllTypeMapListFn = () => {
  queryAllTypeMapList({}).then(res => {
    if (res.data.code == 1004) {
      mapList.value = res.data.dataList;
    }
  }).catch(err => {
    console.log(err);
  });
}

const handleMapChange = (mapId) => {
  if (!mapId) {
    emit('mapChange', undefined);
    return;
  }
  const mapItem = mapList.value.find(e => e.mapId === mapId);
  emit('mapChange', mapItem);
}

const handleClear = () => {
  emit('mapChange', undefined);
}

// 组件挂载后
onMounted(() => {
  queryAllTypeMapListFn();
});
</script>

<style lang='less'>
/* 下拉菜单属于全局挂载，必须在非 scoped 中定义 */
.work-bench-select-dropdown {
  /* 使用 Element Plus 变量和毛玻璃属性 */
  --el-bg-color-overlay: var(--backgroundColor_2, rgba(20, 20, 20, 0.65));
  --el-border-color-light: var(--borderColor_9, #444);
  --el-fill-color-light: var(--backgroundColor_16, rgba(255, 255, 255, 0.1));
  --el-text-color-regular: var(--fontColor_5, #ccc);

  background: var(--el-bg-color-overlay) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid var(--el-border-color-light) !important;

  .el-select-dropdown__item {
    color: var(--el-text-color-regular);
    &.hover, &:hover {
      background-color: var(--el-fill-color-light);
    }
    &.selected {
      color: var(--themeColor, #409eff);
      background-color: transparent;
      font-weight: bold;
    }
  }

  /* 下拉框的小箭头样式适配 */
  .el-popper__arrow::before {
    background: var(--el-bg-color-overlay) !important;
    border: 1px solid var(--el-border-color-light) !important;
  }
}
</style>

<style lang='less' scoped>
.work-bench-select-container {
  flex: 1;
  min-width: 0;

  :deep(.el-select) {
    width: 100%;

    /* 重写 Element Plus 内部 CSS 变量以去边框和背景 */
    --el-input-bg-color: transparent;
    --el-input-border-color: transparent;
    --el-input-hover-border-color: transparent;
    --el-input-focus-border-color: transparent;
    --el-select-input-focus-border-color: transparent;
    --el-select-border-color-hover: transparent;

    /* 兼容 Element Plus 不同版本的 wrapper class */
    .el-input__wrapper,
    .el-select__wrapper {
      background-color: transparent !important;
      box-shadow: none !important;
      padding: 0 4px;
    }
    
    .el-input__inner {
      font-size: 14px;
      font-weight: 500;
      color: var(--fontColor_5);
    }
  }
}
</style>
